// src/components/dashboard/PartnersSection.tsx
// Partnerler sayfası - anlaşmalı partnerler kart kart listelenir (Cenoa vb.)
import React from 'react'
import { motion } from 'framer-motion'
import { DollarSign, ExternalLink, Handshake, LucideIcon } from 'lucide-react'
import { Button } from '../ui/button'

interface Partner {
  name: string
  icon: LucideIcon
  title: string
  description: string
  refLabel?: string
  refCode?: string
  buttonText: string
  url: string
}

const partners: Partner[] = [
  {
    name: 'Cenoa',
    icon: DollarSign,
    title: 'İlk 1000$ için 50$ bonus',
    description:
      'Amazon, Etsy, Upwork, Payoneer, Wise, Stripe ödemelerini Cenoa üzerinden al. Kayıt olurken aşağıdaki referans kodunu kullan.',
    refLabel: 'Referans kodu',
    refCode: 'EBH50',
    buttonText: 'Uygulamayı İndir',
    url: 'https://cenoa.onelink.me/oFPB/i24c29r9',
  },
]

export default function PartnersSection() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <Handshake className="w-6 h-6 text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Partnerler</h1>
          <p className="text-sm text-gray-500">Anlaşmalı partnerlerimiz ve sana özel avantajlar</p>
        </div>
      </div>

      {/* Partner kartları */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {partners.map((p, i) => {
          const Icon = p.icon
          return (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
            >
              <div className="relative overflow-hidden rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 shadow-md p-5 flex flex-col h-full">
                {/* Sol kenar amber çizgi */}
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-amber-400 to-orange-500"></div>

                {/* Başlık */}
                <div className="flex items-center gap-3 mb-3 pl-2">
                  <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-amber-600" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-bold text-amber-900">{p.name}</h3>
                    <p className="text-sm font-medium text-gray-800 leading-snug">{p.title}</p>
                  </div>
                </div>

                {/* Açıklama */}
                <p className="text-sm text-gray-700 leading-relaxed flex-1 pl-2">{p.description}</p>

                {/* Referans kodu */}
                {p.refCode && (
                  <div className="mt-3 pl-2 text-sm text-gray-700">
                    {p.refLabel}:{' '}
                    <span className="font-mono font-bold bg-amber-200 text-amber-900 px-2 py-0.5 rounded">
                      {p.refCode}
                    </span>
                  </div>
                )}

                {/* Buton */}
                <Button
                  className="mt-4 w-full bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-medium shadow-md hover:shadow-lg transition-all duration-200 rounded-lg"
                  onClick={() => window.open(p.url, '_blank')}
                >
                  <ExternalLink className="w-4 h-4 mr-2" />
                  {p.buttonText}
                </Button>
              </div>
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}
